import { render, staticRenderFns } from "./NeoparentCreatePatientEpd.vue?vue&type=template&id=6edf61a2&scoped=true"
import script from "./NeoparentCreatePatientEpd.vue?vue&type=script&lang=js"
export * from "./NeoparentCreatePatientEpd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf61a2",
  null
  
)

export default component.exports